import JB from '../../scripts/JB';

const SELECTOR = '.o-disclosure-documents';

const disclosureDocuments = {
  wrapper: null,
  domicileSelect: null,
  disclosureInputField: null,
  disclosureSubmitButton: null,
  disclosureHintText: null,
  init() {
    this.wrapper = document.querySelector(SELECTOR);
    if (!this.wrapper) {
      return;
    }
    disclosureDocuments.dom();
    disclosureDocuments.bindEvents();
  },
  dom() {
    this.disclosureForm = this.wrapper.querySelector(SELECTOR + '__form');
    this.domicileSelectWrapper = this.wrapper.querySelector(SELECTOR + '__domicile-selection-input');
    this.domicileSelect = this.wrapper.querySelector('.select-list');
    this.domicileSelectOption = this.wrapper.querySelector('.ss-selected-option');
    this.disclosureInputField = this.disclosureForm.querySelector(SELECTOR + '__form-field');
    this.disclosureSubmitButton = this.disclosureForm.querySelector('jb-button-secondary[name="disclosure-submit"]');
    this.disclosureHintText = this.wrapper.querySelector(SELECTOR + '__search-hint-text');
  },
  bindEvents() {
    if (this.domicileSelectWrapper.dataset.domicile !== '') {
      const selectOptions = this.domicileSelectWrapper.querySelectorAll('.ss-option');
      selectOptions.forEach((item) => {
        item.classList.remove('ticked');
        item.classList.remove('highlighted');
        if (item.dataset.value === this.domicileSelectWrapper.dataset.domicile) {
          this.domicileSelectOption.textContent = item.textContent;
          this.domicileSelect.value = item.dataset.value;
          item.classList.add('ticked');
        }
      });
      disclosureDocuments.enableDisclosureInput();
    }
    this.disclosureForm.addEventListener('jb-button:clicked', async (e) => {
      if (e.detail.name === 'disclosure-submit') {
        const valid = JB.validate(this.disclosureForm);
        if (valid) {
          this.disclosureForm.submit();
        }
      }
    });
    this.domicileSelect.addEventListener('change', () => {
      if (this.domicileSelect.value.trim().length !== 0) {
        disclosureDocuments.enableDisclosureInput();
      }
    });
  },
  disableDisclosureInput() {
    this.disclosureInputField.classList.addModifier('disabled');
    this.disclosureSubmitButton.setAttribute('inactive');
    this.disclosureHintText.classList.addModifier('disabled');
  },
  enableDisclosureInput() {
    this.disclosureInputField.classList.removeModifier('disabled');
    this.disclosureSubmitButton.removeAttribute('inactive');
    this.disclosureHintText.classList.removeModifier('disabled');
  },
};

export default disclosureDocuments;
